import { LanguageContext, LanguageContextType } from "@/lib/main";
import { useContext } from "react";

export default function useLanguage(): LanguageContextType {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error(
      "useLanguage must be used within a LanguageContext.Provider",
    );
  }
  return context;
}
